import React from "react";
import ManageAssessment from "../../../../instructor/pages/Assessment/ManageAssessment";
import { ASSESSMENT_TYPES } from "../../../../instructor/pages/Assessment/assessmentType";

// Admins see every class; instructors only their own.
const ManageExam = () => (
  <ManageAssessment type={ASSESSMENT_TYPES.exam} classesUrl="/classes" />
);

export default ManageExam;
